import React from "react";

/**
 * component svg options menu button
 */
const DeleteButton = function (props) {

    return (

        <svg version="1.1" id="options-button" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	        viewBox="0 0 1000 1000">
            <path className="st0" d="M214,482.1"/>
            <line className="st-options" x1="500" y1="250" x2="500" y2="250"/>
            <line className="st-options" x1="500" y1="500" x2="500" y2="500"/>
            <line className="st-options" x1="500" y1="750" x2="500" y2="750"/>
        </svg>

    );
};

export default DeleteButton;